import { createContext, useContext, useState, useRef, useEffect } from 'react';

const WindowContext = /*#__PURE__*/createContext(window);
const {
  Provider: Provider$1,
  Consumer: Consumer$1
} = WindowContext;

const useWindow = () => useContext(WindowContext);
var useWindow$1 = useWindow;

const DocumentContext = /*#__PURE__*/createContext(document);
const {
  Provider,
  Consumer
} = DocumentContext;

const useDocument = () => useContext(DocumentContext);
var useDocument$1 = useDocument;

let ScrollDirection;
(function (ScrollDirection) {
  ScrollDirection["UP"] = "UP";
  ScrollDirection["DOWN"] = "DOWN";
})(ScrollDirection || (ScrollDirection = {}));
function useScrollDirection() {
  let {
    threshold = 0
  } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  const [scrollDirection, setScrollDirection] = useState(ScrollDirection.UP);
  const blocking = useRef(false);
  const prevScrollY = useRef(0);
  useEffect(() => {
    prevScrollY.current = window.pageYOffset;
    const updateScrollDirection = () => {
      const scrollY = window.pageYOffset;
      if (Math.abs(scrollY - prevScrollY.current) >= threshold) {
        const newScrollDirection = scrollY > prevScrollY.current ? ScrollDirection.DOWN : ScrollDirection.UP;
        setScrollDirection(newScrollDirection);
        prevScrollY.current = scrollY > 0 ? scrollY : 0;
      }
      blocking.current = false;
    };
    const onScroll = () => {
      if (!blocking.current) {
        blocking.current = true;
        window.requestAnimationFrame(updateScrollDirection);
      }
    };
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, [scrollDirection, threshold]);
  return scrollDirection;
}

export { Provider as DocumentProvider, ScrollDirection, Provider$1 as WindowProvider, useDocument$1 as useDocument, useScrollDirection, useWindow$1 as useWindow };
